module.exports = __webpack_public_path__ + "public-ui/img/kamkom.ac9a53f4.svg";